<template>
    <div>
        <section class="relative pt-28 md:pb-24 pb-16">
            <div class="container">
                <h1 class="text-2xl font-bold text-gray-800 dark:text-white mb-2">Stripe Dashboard</h1>
                <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 border-2 border-gray-200 dark:border-gray-700 rounded-lg">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" class="px-3 py-3">ID</th>
                            <th scope="col" class="px-3 py-3">Buyer</th>
                            <th scope="col" class="px-3 py-3">Dataset</th>
                            <th scope="col" class="px-3 py-3">Listing</th>
                            <th scope="col" class="px-3 py-3">Seller</th>
                            <th scope="col" class="px-3 py-3">Created At</th>
                            <th scope="col" class="px-3 py-3">Price</th>
                            <th scope="col" class="px-3 py-3">Portex fee</th>
                            <th scope="col" class="px-3 py-3">Total</th>
                            <th scope="col" class="px-3 py-3 text-center">Receipt Address</th>
                            <th scope="col" class="px-3 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sale in sales" :key="sale.id" class="text-center odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200">
                            <td class="px-3 py-4">{{ sale.id }}</td>
                            <td class="px-3 py-4">{{ sale.buyer.username }}</td>
                            <td class="px-3 py-4">{{ sale.listing.datasets[0].name }}</td>
                            <td class="px-3 py-4">{{ sale.listing.name }}</td>
                            <td class="px-3 py-4">{{ sale.listing.datasets[0].seller.user.username }}</td>
                            <td class="px-3 py-4">{{ convertDateToHuman(sale.created_at) }}</td>
                            <td class="px-3 py-4">{{ sale.listing.price }}</td>
                            <td class="px-3 py-4">{{ parseFloat(sale.final_price - sale.listing.price).toFixed(2) }}</td>
                            <td class="px-3 py-4">{{ sale.final_price }}</td>
                            <td class="px-3 py-4">{{ sale.listing.receipt_address }}</td>
                            <td class="px-3 py-4">
                                <button @click="updateSellerPayout(sale.id)" :class="sale.seller_payout ? 'bg-green-500' : 'bg-red-500'"
                                    class="px-4 py-2 rounded-md text-white"
                                >
                                    {{ sale.seller_payout ? 'Paid' : 'Not Paid' }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from '@/plugins/axios';

const sales = ref([]);

const fetchSales = async () => {
    try {
        const response = await axios.get('/api/sales');
        sales.value = response.data.filter(sale => sale.payment_method === 'STRIPE');
    } catch (error) {
        console.error('Error fetching sales:', error);
    }
}

onMounted(() => {
    fetchSales();
});

const convertDateToHuman = (date) => {
    const dateObject = new Date(date);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return dateObject.toLocaleDateString('en-US', options);
}

const updateSellerPayout = async (saleId) => {
    try {
        const response = await axios.post(`/api/sales/update_payout/${saleId}`, {
            seller_payout: !sales.value.find(sale => sale.id === saleId).seller_payout
        });

        if(response.status === 201) {
            fetchSales();
        }
    } catch (error) {
        console.error('Error updating seller payout:', error);
    }
}
</script>